import { useMemo, useState } from 'react'
import { UseQueryResult } from '@tanstack/react-query'
import { ColumnFiltersState, PaginationState } from '@tanstack/react-table'
import { Stack, Title } from '@mantine/core'
import { PageContainer } from '@shared/components/app-shell/page-container/page-container'
import { DEFAULT_PAGINATION_SIZE } from '@shared/components/table/table'
import { TypedLotsTable } from '@/components/typing/typed-lots/typed-lots-table'
import { PAGE_TITLES } from '@/constants/page-titles'
import { TypedLotsListGql } from '@/graphql/queries/typed-lots-table.graphql'
import {
  DatePosition,
  getDatetimeFromDateFilter,
} from '@shared/helpers/get-datetime-from-date-filter/get-datetime-from-date-filter'
import { useAuthenticatedGraphQuery } from '@/hooks/use-authenticated-query'
import { ListTypedWoolLotsOrderByOptions, LoomQuery } from '@loom-api-types'

export function TypedLotsPage() {
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: DEFAULT_PAGINATION_SIZE,
  })
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([
    {
      id: 'lastTyped',
      value: [new Date(), new Date()],
    },
  ])

  const queryParams = useMemo(
    () => ({
      currentPage: pagination.pageIndex + 1,
      pageSize: pagination.pageSize,
      orderBy: ListTypedWoolLotsOrderByOptions.LastTyped,
      orderByAscending: false,
      from: getDatetimeFromDateFilter(columnFilters, 'lastTyped', DatePosition.START),
      to: getDatetimeFromDateFilter(columnFilters, 'lastTyped', DatePosition.END),
    }),
    [pagination.pageIndex, pagination.pageSize, columnFilters]
  )

  const { data, isError, isFetching, isLoading }: UseQueryResult<LoomQuery> =
    useAuthenticatedGraphQuery({
      queryKey: ['listTypedLots', pagination, columnFilters],
      gql: TypedLotsListGql,
      queryParams,
    })

  return (
    <PageContainer title={PAGE_TITLES.TYPED_LOTS}>
      <Stack>
        <Title>Typed Lots</Title>
        <TypedLotsTable
          data={data?.listTypedWoolLots}
          isError={isError}
          isFetching={isFetching}
          isLoading={isLoading}
          pagination={pagination}
          setPagination={setPagination}
          columnFilters={columnFilters}
          setColumnFilters={setColumnFilters}
        />
      </Stack>
    </PageContainer>
  )
}
